// REFACTORED: Single window.ntoState object, all logic in one IIFE.
(function () {

  const root = document.querySelector('.new-to-onyx');
  if (!root) return;

  // ============================================================
  //  SINGLE SOURCE OF TRUTH STATE
  // ============================================================
  // Keep this intentionally small + explicit. Option B (Liquid renders
  // per-product Good outcome blocks) means JS only shows/hides.
  window.ntoState = window.ntoState || {
    product: {
      handle: null,
      id: null,
      title: null,
      url: null,
      image: null,
      price: null,
    },
    guideType: null,          // e.g. "V60" | "Espresso" | ... (human label)
    methodKey: 'filter',      // "filter" | "espresso" | "auto_drip"
    result: null,             // "good" | "bad"
    swiper: null,
    supportTargetIndex: null,
    coffeeCarousel: null,
  };

  const state = window.ntoState;

  // ============================================================
  //  DOM HELPERS (SCOPED)
  // ============================================================
  const $ = (sel, ctx = root) => ctx.querySelector(sel);
  const $$ = (sel, ctx = root) => Array.from(ctx.querySelectorAll(sel));

  const hideAll = (selector) => $$(selector).forEach(el => el.classList.add('hidden'));

  const showOnlyByAttr = (selector, attr, value) => {
    $$(selector).forEach(el => {
      el.classList.toggle('hidden', el.getAttribute(attr) !== value);
    });
  };

  // Force-enable Swiper nav button (Swiper disables next on last slide)
  function forceEnableNextButton(btn) {
    if (!btn) return;
    btn.disabled = false;
    btn.removeAttribute('disabled');
    btn.setAttribute('aria-disabled', 'false');
    if (btn.getAttribute('tabindex') === '-1') btn.removeAttribute('tabindex');
    btn.classList.remove('swiper-button-disabled');
  }

  // ============================================================
  //  SCROLL HINT WATCHER
  // ============================================================
  const scrollEls = $$('.scroll-hint');
  function updateScrollHints() {
    scrollEls.forEach(el => {
      const hasScroll = el.scrollHeight > el.clientHeight + 1;
      el.classList.toggle('has-scroll', hasScroll);

      const atBottom = Math.ceil(el.scrollTop + el.clientHeight) >= el.scrollHeight;
      el.classList.toggle('at-bottom', atBottom);
    });
  }

  scrollEls.forEach(el => {
    const updateScrollState = () => {
      updateScrollHints();
    };

    updateScrollState();
    el.addEventListener('scroll', updateScrollState);
    window.addEventListener('resize', updateScrollState);
  });

  // ============================================================
  //  STATE DERIVATION HELPERS
  // ============================================================
  function deriveMethodKeyFromGuideType(guideType) {
    const gt = String(guideType || '').toLowerCase();
    if (gt.includes('espresso')) return 'espresso';
    if (gt.includes('auto') && gt.includes('drip')) return 'auto_drip';
    return 'filter';
  }

  function computeFirstSupportSlideIndex(swiper) {
    if (!swiper || !swiper.slides) return null;
    for (let i = 0; i < swiper.slides.length; i++) {
      const slide = swiper.slides[i];
      if (slide && slide.classList && slide.classList.contains('nto-support')) {
        return i;
      }
    }
    return null;
  }

  function getActiveSlide(swiper) {
    if (!swiper) return null;
    return swiper.slides ? swiper.slides[swiper.activeIndex] : null;
  }

  function getActiveSlideId(swiper) {
    const slide = getActiveSlide(swiper);
    return (slide?.getAttribute('data-slide-id') || '').trim();
  }

  // ============================================================
  //  RENDERERS (STATE → UI)
  // ============================================================
  function renderProductSelection() {
    if (!state.product.handle) return;
    // product button selected class
    $$('[data-nto-choice][data-key="coffee"]').forEach(btn => {
      btn.classList.toggle('selected', btn.dataset.product === state.product.handle);
    });
    updateCoffeeCarouselFromHandle(state.product.handle);

    // method UI for this product
    showOnlyByAttr('.select-method-content', 'data-product', state.product.handle);

    // product description + gradient
    $$('.product-description').forEach(desc => {
      desc.classList.toggle('hidden', desc.dataset.product !== state.product.handle);
    });
    $$('.product-description-gradient').forEach(grad => {
      grad.classList.toggle('invisible', grad.dataset.product !== state.product.handle);
    });
    requestAnimationFrame(updateScrollHints);
  }

  function renderGuideBlocks() {
    // Hide all guide blocks
    $$('.nto-guide-block').forEach(el => {
      el.style.display = 'none';
    });

    if (!state.product.handle || !state.guideType) return;

    const selector = `.nto-guide-block[data-product="${CSS.escape(state.product.handle)}"][data-guide-type="${CSS.escape(state.guideType)}"]`;
    const matches = $$(selector);
    matches.forEach(el => {
      el.style.display = '';
    });

    if (!matches.length) {
      console.warn('[help-me-brew] No guide block match for:', {
        product: state.product.handle,
        guideType: state.guideType,
        selector
      });
    }
  }

  function renderEndScreenBlocks() {
    // End screen contains multiple result-blocks; we show exactly one depending on state.
    const resultBlocks = $$('.result-block');
    resultBlocks.forEach(block => block.classList.add('hidden'));

    const endSlideEl = $('.swiper-slide.end-screen', root) || document.querySelector('.swiper-slide.end-screen');

    if (state.result === 'good') {
      // OPTION B: Liquid renders one good block per product.
      const handle = state.product.handle;
      const goodMatch = handle
        ? $(`.result-block.result-good[data-result="good"][data-product="${CSS.escape(handle)}"]`, root)
        : null;

      const goodFallback = $(`.result-block.result-good[data-result="good"]`, root);
      (goodMatch || goodFallback)?.classList.remove('hidden');

      if (endSlideEl) endSlideEl.setAttribute('data-next-label', 'Done');

    } else if (state.result === 'bad') {
      const methodKey = state.methodKey || 'filter';
      const badMatch = $(`.result-block.result-bad-support[data-result="bad"][data-method-key="${CSS.escape(methodKey)}"]`, root);
      const badFallback = $(`.result-block.result-bad-support[data-result="bad"]`, root);
      (badMatch || badFallback)?.classList.remove('hidden');

      if (endSlideEl) endSlideEl.setAttribute('data-next-label', 'Retry');
    }
  }

  // ============================================================
  //  ACCORDIONS (Post-brew support)
  // ============================================================
  function initAccordion() {
    // Event delegation scoped to this experience only
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('.nto-accordion__toggle');
      if (!btn || !root.contains(btn)) return;

      const accordion = btn.closest('[data-nto-accordion]');
      const item = btn.closest('.nto-accordion__item');
      const panel = item?.querySelector('.nto-accordion__panel');
      if (!accordion || !panel) return;

      const isOpen = btn.getAttribute('aria-expanded') === 'true';

      // Close other open items (single-open behavior)
      accordion
        .querySelectorAll('.nto-accordion__toggle[aria-expanded="true"]')
        .forEach((openBtn) => {
          if (openBtn === btn) return;
          openBtn.setAttribute('aria-expanded', 'false');
          const openPanel = openBtn
            .closest('.nto-accordion__item')
            ?.querySelector('.nto-accordion__panel');
          if (openPanel) openPanel.hidden = true;
        });

      // Toggle clicked one
      btn.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
    });
  }

  // ============================================================
  //  PROGRESS + NAV LABELS
  // ============================================================
  function updateProgressBar(swiper) {
    const current = swiper.activeIndex + 1;
    const total = swiper.slides.length;
    const percent = (current / total) * 100;

    const fill = $('.nto-progress__fill', root);
    if (fill) fill.style.width = percent + '%';
  }

  function updateNextButton(swiper) {
    const nextButton = $('.nto-next', root);
    if (!nextButton) return;

    const currentSlide = getActiveSlide(swiper);
    const slideId = currentSlide?.getAttribute('data-slide-id') || '';

    // If we're on the end screen, label is driven by result
    if (slideId === 'end') {
      const label = (state.result === 'bad') ? 'Retry' : (state.result === 'good') ? 'Done' : 'Next';
      nextButton.textContent = label;
      nextButton.setAttribute('aria-label', label);
      if (label.toLowerCase() === 'retry' || label.toLowerCase() === 'done') {
        forceEnableNextButton(nextButton);
      }
      return;
    }

    // Otherwise: slide-level data-next-label
    const label = (currentSlide?.getAttribute('data-next-label') || 'Next').trim();
    nextButton.textContent = label;
    nextButton.setAttribute('aria-label', label);
    if (label.toLowerCase() === 'retry') forceEnableNextButton(nextButton);
  }

  // ============================================================
  //  RESULT SCREEN (GOOD/BAD) CLICK HANDLING
  // ============================================================
  function initResultChoice() {
    const resultButtons = $$('[data-result-value]');

    resultButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const value = btn.dataset.resultValue; // "good" | "bad"

        // UI selected state
        resultButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');

        // Update state
        state.result = value;

        // Keep guideType/methodKey in sync from earlier selections
        state.methodKey = state.methodKey || deriveMethodKeyFromGuideType(state.guideType);

        // Cache first support slide index (used when clicking Retry on end-screen)
        state.supportTargetIndex = computeFirstSupportSlideIndex(state.swiper);

        // Render end screen blocks based on state
        renderEndScreenBlocks();

        // Advance to the end slide
        if (state.swiper) state.swiper.slideNext();
      });
    });
  }

  // ============================================================
  //  NEXT BUTTON PRESS ANIMATION
  // ============================================================
  const nextBtn = $('.nto-next', root);
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      nextBtn.classList.remove('pressed');
      void nextBtn.offsetWidth;
      nextBtn.classList.add('pressed');
    });
  }

  // ============================================================
  //  FINAL SCREEN FLOW
  //  - Done returns home.
  //  - Retry resets the experience to the beginning.
  // ============================================================
  function resetResultUI() {
    // Clear result + any shown blocks
    state.result = null;

    // Clear selected result button styling
    $$('[data-result-value].selected').forEach(el => el.classList.remove('selected'));

    // Hide all result blocks
    $$('.result-block').forEach(el => el.classList.add('hidden'));
  }

  function resetExperience() {
    const swiper = state.swiper;

    resetResultUI();
    state.guideType = null;
    state.methodKey = 'filter';

    $$('[data-nto-choice].selected, .method-option.selected').forEach(el => {
      el.classList.remove('selected');
    });

    const firstProduct = $('[data-nto-choice][data-key="coffee"]', root);
    if (firstProduct) setProductFromButton(firstProduct);

    $$('.scroll-hint').forEach(el => {
      el.scrollTop = 0;
    });

    if (swiper) {
      swiper.slideTo(0, 0);
      updateProgressBar(swiper);
      updateNextButton(swiper);
      updateNavVisibility(swiper);
    }

    requestAnimationFrame(updateScrollHints);
  }

  function initFinalNavHandlers() {
    const next = $('.nto-next', root);
    if (!next) return;

    next.addEventListener('click', (e) => {
      const swiper = state.swiper;
      if (!swiper) return;

      // Only hijack clicks on the end screen slide
      if (getActiveSlideId(swiper) !== 'end') return;

      const actionLabel = (next.textContent || next.getAttribute('aria-label') || '').trim().toLowerCase();

      // GOOD outcome: "Done" should leave the flow and return home.
      if (state.result === 'good' || actionLabel === 'done') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        window.location.href = '/';
        return;
      }

      // BAD outcome: "Retry" should reset the experience.
      if (state.result === 'bad' || actionLabel === 'retry') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        resetExperience();
      }
    }, true);
  }

  // ============================================================
  //  NAV VISIBILITY + FORCE ENABLE
  // ============================================================
  function updateNavVisibility(swiper) {
    const next = $('.nto-next', root);
    const prev = $('.nto-prev', root);
    if (!next || !prev) return;

    const activeSlide = getActiveSlide(swiper);

    // Existing behavior: hide both (for “no nav” slides)
    const hideNav = activeSlide?.dataset.hideNav === 'true';

    // New behavior: optionally hide ONLY next/prev
    const hideNext = hideNav || activeSlide?.dataset.hideNext === 'true';
    const hidePrev = hideNav || activeSlide?.dataset.hidePrev === 'true';

    next.classList.toggle('hidden', hideNext);
    prev.classList.toggle('hidden', hidePrev);

    // Keep final-screen actions enabled even though Swiper sees this as the last slide.
    const slideLabel = (activeSlide?.getAttribute('data-next-label') || '').trim().toLowerCase();
    const ariaLabel = (next.getAttribute('aria-label') || '').trim().toLowerCase();
    const textLabel = (next.textContent || '').trim().toLowerCase();

    const shouldForce = slideLabel === 'retry'
      || ariaLabel === 'retry'
      || textLabel === 'retry'
      || slideLabel === 'done'
      || ariaLabel === 'done'
      || textLabel === 'done';
    if (shouldForce) forceEnableNextButton(next);
  }

  // ============================================================
  //  SWIPER INIT
  // ============================================================
  function initSwiper() {
    const swiper = new Swiper('.nto-swiper', {
      slidesPerView: 1,
      allowTouchMove: false,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      nested: true,
      navigation: {
        nextEl: $('.nto-next', root),
        prevEl: $('.nto-prev', root)
      },
      on: {
        init(sw) {
          state.swiper = sw;
          state.supportTargetIndex = computeFirstSupportSlideIndex(sw);
          updateProgressBar(sw);
          updateNextButton(sw);
          updateNavVisibility(sw);
        },
        slideChange(sw) {
          updateProgressBar(sw);
          updateNextButton(sw);
          updateNavVisibility(sw);
        }
      }
    });

    state.swiper = swiper;
    state.supportTargetIndex = computeFirstSupportSlideIndex(swiper);
    return swiper;
  }

  // ============================================================
  //  PRODUCT + METHOD SELECTION (STATE SETTERS)
  // ============================================================
  function setProductFromButton(btn) {
    if (!btn) return;

    const handle = btn.dataset.product || null;
    if (!handle) return;

    // Minimal for now; add more fields when Liquid adds them.
    state.product.handle = handle;
    state.product.id = btn.dataset.productId || state.product.id;
    state.product.title = btn.dataset.productTitle || state.product.title;
    state.product.url = btn.dataset.productUrl || state.product.url;
    state.product.image = btn.dataset.productImage || state.product.image;
    state.product.price = btn.dataset.productPrice || state.product.price;

    // Changing product should clear result selection
    resetResultUI();

    renderProductSelection();

    // If there is a method already selected for this product, keep it.
    // Otherwise auto-select first method.
    const methodContainer = $(`.select-method-content[data-product="${CSS.escape(handle)}"]`, root);
    const firstMethod = methodContainer?.querySelector('.method-option[data-guide-type]');
    if (firstMethod) {
      setMethodFromButton(firstMethod);
    }
  }

  function setMethodFromButton(methodBtn) {
    if (!methodBtn) return;

    const guideType = methodBtn.dataset.guideType;
    if (!guideType) return;

    state.guideType = guideType;
    state.methodKey = deriveMethodKeyFromGuideType(guideType);

    // Selected state within this product’s method list
    const container = methodBtn.closest('.select-method-content');
    container?.querySelectorAll('.method-option').forEach(btn => {
      btn.classList.toggle('selected', btn === methodBtn);
    });

    // Changing method should clear result selection
    resetResultUI();

    renderGuideBlocks();
  }

  function initSelectionControls() {
    // Product buttons
    const productButtons = $$('[data-nto-choice][data-key="coffee"]');
    productButtons.forEach(btn => {
      btn.addEventListener('click', () => setProductFromButton(btn));
    });

    // Method buttons
    $$('.method-option[data-guide-type]').forEach(btn => {
      btn.addEventListener('click', () => setMethodFromButton(btn));
    });

    // Initial load — pick first product
    if (productButtons.length > 0) {
      setProductFromButton(productButtons[0]);
    }
  }

  // ============================================================
  //  PRODUCT SELECTION COFFEE CAROUSEL
  // ============================================================
  function getCoffeeCarouselMaxIndex(carousel) {
    return Math.max(0, carousel.buttons.length - 1);
  }

  function clampCoffeeCarouselPosition(carousel, position) {
    return Math.min(getCoffeeCarouselMaxIndex(carousel), Math.max(0, position));
  }

  function getWrappedCoffeeCarouselPosition(carousel, position) {
    const total = carousel.buttons.length;
    if (!total) return 0;
    return ((position % total) + total) % total;
  }

  function getWrappedCoffeeCarouselDistance(index, position, total) {
    let distance = index - position;
    if (Math.abs(distance) > total / 2) {
      distance += distance > 0 ? -total : total;
    }
    return distance;
  }

  function updateCoffeeCarouselUI(position, options = {}) {
    const carousel = state.coffeeCarousel;
    if (!carousel) return;

    const { buttons, grid } = carousel;
    const total = buttons.length;
    if (!total) return;

    const shouldCommit = options.commit !== false;
    const activePosition = getWrappedCoffeeCarouselPosition(carousel, position);
    const selectedIndex = Math.round(activePosition) % total;

    if (shouldCommit) carousel.activeIndex = selectedIndex;
    carousel.position = activePosition;
    grid.style.setProperty('--coffee-count', total);

    buttons.forEach((btn, i) => {
      const distance = getWrappedCoffeeCarouselDistance(i, activePosition, total);
      const abs = Math.abs(distance);
      const cappedAbs = Math.min(abs, 3);
      const direction = distance === 0 ? 0 : distance > 0 ? 1 : -1;
      const isSelected = i === selectedIndex;
      const isVisible = abs < 3;

      btn.classList.toggle('is-active', isSelected);
      btn.classList.toggle('is-prev', Math.round(distance) === -1);
      btn.classList.toggle('is-next', Math.round(distance) === 1);
      btn.classList.toggle('is-hidden-card', !isVisible);
      btn.setAttribute('aria-hidden', !isVisible ? 'true' : 'false');
      btn.style.setProperty('--carousel-offset', distance);
      btn.style.setProperty('--carousel-scale', String(Math.max(0.52, 1 - cappedAbs * 0.16)));
      btn.style.setProperty('--carousel-opacity', isVisible ? '1' : '0');
      btn.style.setProperty('--carousel-rotate', `${direction * -12}deg`);
      btn.style.setProperty('--carousel-depth', `${cappedAbs * -38}px`);
      btn.style.setProperty('--carousel-z', String(100 - Math.round(abs * 10)));
    });
  }

  function updateCoffeeCarouselFromHandle(handle) {
    const carousel = state.coffeeCarousel;
    if (!carousel || !handle) return;

    const index = carousel.buttons.findIndex(btn => btn.dataset.product === handle);
    if (index >= 0) updateCoffeeCarouselUI(index);
  }

  function setCoffeeCarouselIndex(index, shouldSelect = true) {
    const carousel = state.coffeeCarousel;
    if (!carousel) return;

    const wrappedIndex = getWrappedCoffeeCarouselPosition(carousel, Math.round(index));
    updateCoffeeCarouselUI(wrappedIndex);
    if (shouldSelect) {
      const activeButton = carousel.buttons[carousel.activeIndex];
      if (activeButton) setProductFromButton(activeButton);
    }
  }

  function initCoffeeCarousel() {
    const grid = $('.nto-coffee-grid', root);
    if (!grid) return;

    const buttons = $$('[data-nto-choice][data-key="coffee"]', grid);
    if (!buttons.length) return;

    const prev = $('[data-coffee-carousel-prev]', grid);
    const next = $('[data-coffee-carousel-next]', grid);

    state.coffeeCarousel = {
      grid,
      buttons,
      prev,
      next,
      activeIndex: 0,
      position: 0,
      pointerId: null,
      dragStartX: null,
      dragStartY: null,
      dragDeltaX: 0,
      dragStartPosition: 0,
      hasDragged: false,
    };

    grid.classList.add('has-coffee-carousel');
    grid.classList.toggle('has-single-coffee', buttons.length === 1);
    updateCoffeeCarouselUI(0);

    buttons.forEach((btn, index) => {
      btn.addEventListener('click', (e) => {
        if (state.coffeeCarousel.hasDragged) {
          e.preventDefault();
          e.stopImmediatePropagation();
          state.coffeeCarousel.hasDragged = false;
          return;
        }
        if (index === state.coffeeCarousel.activeIndex) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        setCoffeeCarouselIndex(index);
      }, true);
    });

    [prev, next].forEach((nav) => {
      nav?.addEventListener('pointerdown', (e) => {
        e.stopPropagation();
      });
    });

    prev?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      setCoffeeCarouselIndex(state.coffeeCarousel.activeIndex - 1);
    });
    next?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      setCoffeeCarouselIndex(state.coffeeCarousel.activeIndex + 1);
    });

    grid.addEventListener('pointerdown', (e) => {
      if (!e.isPrimary) return;
      const carousel = state.coffeeCarousel;
      carousel.pointerId = e.pointerId;
      carousel.dragStartX = e.clientX;
      carousel.dragStartY = e.clientY;
      carousel.dragDeltaX = 0;
      carousel.dragStartPosition = carousel.activeIndex;
      carousel.hasDragged = false;
      grid.classList.add('is-dragging');
      grid.setPointerCapture?.(e.pointerId);
    });

    grid.addEventListener('pointermove', (e) => {
      const carousel = state.coffeeCarousel;
      if (carousel.pointerId !== e.pointerId || carousel.dragStartX === null) return;

      const deltaX = e.clientX - carousel.dragStartX;
      const deltaY = e.clientY - carousel.dragStartY;
      if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 10) return;

      carousel.dragDeltaX = deltaX;
      carousel.hasDragged = Math.abs(deltaX) > 8;
      const cardShift = parseFloat(getComputedStyle(grid).getPropertyValue('--carousel-card-shift')) || 118;
      const dragPosition = carousel.dragStartPosition - (deltaX / cardShift);
      updateCoffeeCarouselUI(dragPosition, { commit: false });
      e.preventDefault();
    });

    function endDrag(e) {
      const carousel = state.coffeeCarousel;
      if (!carousel || carousel.pointerId !== e.pointerId) return;

      const deltaX = carousel.dragDeltaX;
      carousel.pointerId = null;
      carousel.dragStartX = null;
      carousel.dragStartY = null;
      carousel.dragDeltaX = 0;
      grid.classList.remove('is-dragging');
      grid.releasePointerCapture?.(e.pointerId);

      const cardShift = parseFloat(getComputedStyle(grid).getPropertyValue('--carousel-card-shift')) || 118;
      const targetPosition = carousel.dragStartPosition - (deltaX / cardShift);
      const targetIndex = Math.round(getWrappedCoffeeCarouselPosition(carousel, targetPosition));
      setCoffeeCarouselIndex(targetIndex);
    }

    grid.addEventListener('pointerup', endDrag);
    grid.addEventListener('pointercancel', endDrag);
  }

  // ============================================================
  //  INIT
  // ============================================================
  function init() {
    initSwiper();
    initAccordion();
    initCoffeeCarousel();
    initSelectionControls();
    initResultChoice();
    initFinalNavHandlers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
